import { gql } from "@apollo/client";

export const GET_COLLECTIONS_FOR_SELECT = gql`
  query GET_COLLECTIONS_FOR_SELECT {
    findManyCollection {
      id
      product_containers {
        id
      }
      collection_profiles {
        id
        name
        language
      }
    }
  }
`;

export const UPDATE_COLLECTION = gql`
  mutation UPDATE_COLLECTION(
    $where: CollectionWhereUniqueInput!
    $collection_profiles: [CollectionProfileCustomInput!]!
    $images: [String]
    $selected_products: [ProductContainerWhereUniqueInput]!
  ) {
    updateExistingCollection(
      where: $where
      collection_profiles: $collection_profiles
      images: $images
      selected_products: $selected_products
    ) {
      id
    }
  }
`;

export const CREATE_COLLECTION = gql`
mutation CREATE_COLLECTION($collection_profiles: [CollectionProfileCustomInput!]!, $images: [String], $selected_products: [ProductContainerWhereUniqueInput]!) {
  createNewCollection(
    collection_profiles: $collection_profiles
    images: $images
    selected_products: $selected_products
  ) {
    id
  }
}

`;

export const GET_COLLECTIONS = gql`
  query GET_COLLECTIONS($searchTerm: String, $language: Language, $take: Int, $skip: Int, $orderBy: [CollectionOrderByWithRelationInput!]) {
    findManyCollectionCount(
      where: {collection_profiles: {some: {name: {mode: insensitive, contains: $searchTerm}, language: { equals: $language}}}}
    )
    findManyCollection(
      orderBy: $orderBy
      where: {collection_profiles: {some: {name: {mode: insensitive, contains: $searchTerm}, language: { equals: $language}}}}
      take: $take
      skip: $skip
    ) {
      id
      main_image {
        id
        src
      }
      product_containers {
        id
      }
      collection_profiles ( where: { language: { equals: $language } }) {
        id
        name
        description
        language
        meta_information {
          id
          permalink
          meta_title
          meta_description
        }
      }
    }
  }
`;

export const DELETE_MANY_COLLECTIONS = gql`
  mutation DELETE_MANY__COLLECTIONS($ids: [Int!]!) {
    deleteManyCollection(where: { id: { in: $ids } }) {
      count
    }
  }
`;

export const GET_COLLECTION = gql`
  query GET_COLLECTION($id: Int!) {
    findUniqueCollection(where: { id: $id }) {
      id
      collection_profiles {
        id
        name
        description
        language
        meta_information {
          id
          permalink
          meta_title
          meta_description
        }
      }
      main_image {
        id
        src
      }
      product_containers {
        id
      }
    }
  }
`;
